import { Navigate, useRoutes } from 'react-router-dom';
import { mainRoutes } from './main';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import { publicFormRoutes } from './public';
import { legalRoutes } from './legal';
import { settingRoutes } from './settings';
import { PATH_AFTER_LOGIN } from '@/config-global';
import { managementRoutes } from './management';

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    // Public routes (no auth required)
    ...publicFormRoutes,
    ...legalRoutes,

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...dashboardRoutes,
    ...settingRoutes,
    ...managementRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
